import type { ExportGroupFailure } from '../types';

export type ExportFailuresBySystemName = ReadonlyMap<
  string,
  readonly ExportGroupFailure[]
>;

export function normalizeExportSystemName(systemName: string): string {
  return systemName.trim().toLocaleLowerCase();
}

export function indexExportFailuresBySystemName(
  failures: readonly ExportGroupFailure[],
): ExportFailuresBySystemName {
  const indexed = new Map<string, ExportGroupFailure[]>();

  failures.forEach((failure) => {
    const key = normalizeExportSystemName(failure.systemName);
    if (!key) {
      return;
    }

    const existing = indexed.get(key) ?? [];
    existing.push(failure);
    indexed.set(key, existing);
  });

  return indexed;
}

export function getExportFailuresForSystem(
  failuresBySystemName: ExportFailuresBySystemName,
  systemName: string,
): readonly ExportGroupFailure[] {
  return failuresBySystemName.get(normalizeExportSystemName(systemName)) ?? [];
}
